/**
 * ReportCalendarPageNew — spec §5.5 with CalendarGrid primitive, trip summary header.
 */
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTripVisitCalendar } from '../hooks/useReports';
import { useTrip } from '../hooks/useTrips';
import { CalendarGrid } from '../design-system/primitives/CalendarGrid';
import { SkeletonRow } from '../design-system/primitives/SkeletonRow';
import { EmptyState } from '../design-system/primitives/EmptyState';
import { ArrowLeft, Calendar } from 'lucide-react';

export function ReportCalendarPageNew(): React.ReactElement {
  const { tripId } = useParams<{ tripId: string }>();
  const navigate = useNavigate();
  const { data: trip } = useTrip(tripId || '');
  console.log(trip);
  const { data: visits, isLoading } = useTripVisitCalendar(tripId || '');

  const days = React.useMemo(() =>
    (visits ?? []).map((v) => ({ date: v.date, parks: v.parks, visitCount: v.visitCount ?? 0, visitPeriod: v.visitPeriod })),
    [visits],
  );

  if (!trip) {
    return (
      <div className="space-y-6">
        <button onClick={() => navigate('/admin/reports')}
          className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800 inline-flex items-center gap-1 text-sm text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors">
          <ArrowLeft className="w-5 h-5" />
          <span>Back to Reports</span>
        </button>
        <SkeletonRow count={4} width="100%" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <button onClick={() => navigate('/admin/reports')}
        className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800 inline-flex items-center gap-1 text-sm text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors">
        <ArrowLeft className="w-5 h-5" />
        <span>Back to Reports</span>
      </button>
      <div className="flex items-center gap-2">
        <Calendar className="w-6 h-6 text-disney-blue-500" />
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">{trip?.name}</h1>
      </div>
      {
        trip && (
          <p className="text-sm text-gray-600 dark:text-gray-300">
            {trip.startDate} — {trip.endDate}
          </p>
        )
      }
      {
        trip && isLoading ? (
          <SkeletonRow count={4} width="100%" />
        ) : visits?.length ? (
          <CalendarGrid days={days} startDate={trip?.startDate || ''} endDate={trip?.endDate || ''} />
        ) : (
          <EmptyState icon={Calendar} iconColor="text-gray-400" title="No visits for this trip" />
        )
      }
    </div >
  );
}
